<template>
  <div class="row">
    <div class="col-3 col-sm-4">
      <img class="img-fluid" v-bind:src="disp.previewImage" alt="[picture]" />
    </div>
    <div class="col-9 col-sm-8">
      <div class="cool-description">
        <router-link :to="{ name: 'details', params: { id: disp.displayid }}">
          <div>
            <h2 class="cool-title">{{disp.title}}</h2>
            <span v-if="disp.isMusical">🎵</span>
          </div>
        </router-link>
        {{disp.city}}, {{disp.state}}
        <br />
        <span class="votes">Votes:&nbsp;{{disp.votes}}</span>
        <span class="distance">{{disp.distanceDescription}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OneDisplay",
  props: {
    disp: {
      type: Object
    }
  },
  methods: {
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    }
  }
};
</script>

<style scoped>
.cool-title {
  font-size: 1.2em;
  text-decoration: underline;
  margin-top: 0px;
  margin-bottom: 0px;
  display: inline;
}

.cool-description {
  line-height: 1em;
  text-align: left;
  margin-left: 0.5em;
}

.votes {
  color: green;
  font-style: italic;
  font-size: 0.8em;
}
.distance {
  margin-left: 0.3em;
  color: darkred;
  font-style: italic;
  font-size: 0.8em;
}
</style>
